<template>
  <div>
    <div class="l-container">
      <p></p>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getTutor_channels()
      vm.getChannels()
      vm.getOffice_channels()
      vm.getPrefs()
    })
  },
  methods: {
    getTutor_channels () {
      this.$store.dispatch('getTutor_channels')
    },
    getChannels () {
      this.$store.dispatch('getChannels')
    },
    getOffice_channels () {
      this.$store.dispatch('getOffice_channels')
    },
    getPrefs () {
      this.$store.dispatch('getPrefs')
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Tutor_channels.vue?0e9fff08